import { Fragment, useEffect, useRef, useState } from 'react';
import Spinner from '../../../components/spinner/Spinner';
import './GridReportsList.css';
import { DeleteSalesCompany, DeleteSalesCompanyTask, GetUserReportsList } from '../../../Services';
import { Link, useNavigate, useParams } from 'react-router-dom';
import PageHeadline from '../../../components/pageHeadline/PageHeadline';
import { toast } from 'react-toastify';
import Moment from 'react-moment';
import moment from 'moment';
import { useStateValue } from '../../../StateProvider';
import TableFooter from '../../../components/table/footer/TableFooter';
import { GetUserReportFilenames } from '../../../ReportAPI';

const GridReportsList = () => {
	const [ isLoading, setIsLoading ] = useState(false);
	const [ allReports, setAllReports ] = useState();
	const [ reportsPendingView, setReportsPendingView ] = useState();
	const [ reportsDoneView, setReportsDoneView ] = useState();
	const [ reportsFilenames, setReportsFilenames ] = useState();
	const [ { user }, dispatch ] = useStateValue();
	const searchListInputRef = useRef();

	useEffect(() => {
		getReportsList(true);
		getReportsFilenames();

		let interval = setInterval(() => {
			getReportsList();
			getReportsFilenames();
		}, 5000);

		return () => {
			clearInterval(interval);
		};
	}, []);

	const filterList = () => {
		if (allReports && allReports.length > 0) {
			setReportHistoryView(allReports);
		}
	};

	const onSearchChange = (e) => {
		if (searchListInputRef.current) {
			if (searchListInputRef.current.value === '') {
				searchListInputRef.current.classList.remove('has-value');
			} else {
				searchListInputRef.current.classList.add('has-value');
			}
		}

		filterList();
	};

	const getReportsList = async (fullReload = false) => {
		if (fullReload) {
			setIsLoading(true);
		}

		let response = await GetUserReportsList(user.id);

		if (response && response.length > 0) {
			let tempAllReports = response;

			tempAllReports = tempAllReports.sort((a, b) => {
				return new Date(b.dateCreated) - new Date(a.dateCreated);
			});

			setAllReports(tempAllReports);

			setReportHistoryView(tempAllReports);
		} else {
			setReportsPendingView();
			setReportsDoneView();
		}

		setIsLoading(false);
	};

	const getReportsFilenames = async () => {
		let response = await GetUserReportFilenames(user.id);

		if (response) {
			setReportsFilenames(JSON.stringify(response));
		}
	};

	const setReportHistoryView = (reports) => {
		let tempReportsView = reports;

		if (searchListInputRef.current && searchListInputRef.current.value) {
			tempReportsView = reports.filter(
				(x) =>
					x.companyName &&
					x.companyName.toLowerCase().includes(searchListInputRef.current.value.toLowerCase())
			);
		}

		tempReportsView = tempReportsView.sort(function(a, b) {
			return new Date(b.lastReportDate) - new Date(a.lastReportDate);
		});

		tempReportsView.map((report, index) => {
			report.keywordsCount = 0;

			if (report.keyword) {
				if (report.keyword.indexOf(',') > -1) {
					report.keywordsCount = report.keyword.split(',').length;
				} else {
					report.keywordsCount = report.keyword.split('\n').length;
				}
			}
		});

		let tempPending = tempReportsView.filter(
			(x) => x.reportStatus === 'Pending' || x.reportStatus === 'Processing'
		);

		if (tempPending) {
			tempPending = tempPending.sort(function(a, b) {
				return (
					b.reportStatus.localeCompare(a.reportStatus) ||
					new Date(b.lastReportDate) - new Date(a.lastReportDate)
				);
			});
		}

		let tempDone = tempReportsView.filter((x) => x.reportStatus === 'Done' || x.reportStatus === 'Error');

		setReportsPendingView(tempPending);
		setReportsDoneView(tempDone);
	};

	const handleDeleteReport = async (e, companyId, taskId) => {
		e.preventDefault();

		if (window.confirm('Are you sure that you want to delete selected report?')) {
			const response = await DeleteSalesCompanyTask(companyId, taskId);

			if (response.success) {
				toast.success('Business successfully deleted');

				getReportsList();
			} else {
				console.log('Failed while delete report: ' + taskId + '; ' + response.message);
			}
		}
	};

	const ifReportHasAuditData = (id) => {
		if (reportsFilenames && reportsFilenames.indexOf(id) > -1) {
			return true;
		} else {
			return false;
		}
	};

	return (
		<Fragment>
			<div className="container-fluid p-0">
				<div className="row">
					<div className="col-12">
						<PageHeadline
							//headline="Reports"
							leftSideHtml={
								<Link type="button" className="btn btn-primary" to="/business-select">
									New Grid Report
								</Link>
								// <Link type="button" className="btn btn-primary" to="/profile-connect">
								// 	New Grid Report
								// </Link>
							}
							buttonsHtml={
								<Fragment>
									{user && (
										<div className="d-flex justify-content-end">
											<div className="search-list-wrapper align-self-start">
												<input
													type="search"
													className="form-control"
													name="searchListTerm"
													onChange={onSearchChange}
													placeholder="Search List"
													ref={searchListInputRef}
													tabIndex="0"
												/>
												<button type="button" className="btn btn-link btn-search px-2">
													<i className="fa fa-search me-0" />
												</button>
											</div>
										</div>
									)}
								</Fragment>
							}
						/>
					</div>
				</div>

				<div className="main-content-container reports-list-container">
					<div className="main-content-inner-container">
						<table className="items-list grid-reports-list table table-responsive">
							<thead>
								<tr>
									<th className="date text-start d-none d-sm-table-cell" scope="col">
										Date
									</th>
									<th scope="col">Business</th>
									<th className="count d-none d-sm-table-cell" scope="col">
										Keywords
									</th>
									<th className="report-status d-none d-sm-table-cell" scope="col">
										Grid
									</th>
									<th className="report-status d-none d-sm-table-cell" scope="col">
										Audit
									</th>
									<th className="report-status text-center d-none d-sm-table-cell" scope="col">
										Status
									</th>
									<th scope="col" className="task-action" />
								</tr>
							</thead>
							{isLoading ? (
								<tbody>
									<tr>
										<td className="p-3" colSpan={11}>
											<Spinner />
										</td>
									</tr>
								</tbody>
							) : (
								<Fragment>
									{(!reportsPendingView || reportsPendingView.length === 0) &&
									(!reportsDoneView || reportsDoneView.length === 0) && (
										<tbody>
											<tr>
												<td className="p-3" colSpan={7}>
													<i>No reports</i>
												</td>
											</tr>
										</tbody>
									)}

									{reportsPendingView &&
									reportsPendingView.length > 0 && (
										<tbody className="table-body-queue">
											{reportsPendingView.map((report, index) => {
												let gridReportExists =
													report.action && report.action.indexOf('Grid') > -1;
												let auditReportExists =
													report.action && report.action.indexOf('Audit') > -1;

												return (
													<tr key={index}>
														<td className="date text-start d-none d-sm-table-cell">
															{report.dateCreated ? (
																<Moment format="MM/DD/YYYY">
																	{report.dateCreated}
																</Moment>
															) : (
																''
															)}
														</td>
														<td>
															{report.companyName}
															{report.googleBusinessUrl ? (
																<a
																	className="btn btn-link p-0"
																	href={report.googleBusinessUrl}
																	target="_blank"
																	title="View Google Business Profile"
																>
																	<i className="fa-solid fa-arrow-up-right-from-square ms-2" />
																</a>
															) : (
																<Fragment />
															)}
														</td>
														<td className="count d-none d-sm-table-cell">
															{report.keywordsCount}
														</td>
														<td className="report-status d-none d-sm-table-cell">
															{gridReportExists ? 'Y' : 'N'}
														</td>
														<td className="report-status d-none d-sm-table-cell">
															{auditReportExists ? 'Y' : 'N'}
														</td>
														<td className="report-status text-center d-none d-sm-table-cell">
															{/* {report.reportStatus} */}
															{report.reportStatus === 'Processing' && (
																<i
																	className="fa-solid fa-gear fa-spin"
																	title="Processing"
																/>
															)}
															{report.reportStatus === 'Pending' && (
																<i className="fa-regular fa-clock" title="Pending" />
															)}
														</td>
														<td className="task-action text-end">
															{/* <Link
																to={`/reports/${report.id}`}
																className="btn btn-link py-0"
																title="View Report"
															>
																<i className="fa-solid fa-magnifying-glass-chart" />
															</Link>
															<button
																type="button"
																className="btn btn-link py-0 text-danger"
																title="Delete Report"
																onClick={(e) =>
																	handleDeleteReport(e, report.companyId, report.id)}
															>
																<i className="fa-solid fa-trash-can" />
															</button> */}
														</td>
													</tr>
												);
											})}
											{/* <tr className="separator-row">
												<td colSpan={7} />
											</tr> */}
										</tbody>
									)}

									{reportsDoneView &&
									reportsDoneView.length > 0 && (
										<tbody>
											{reportsDoneView.map((report, index) => {
												let auditReportExists = ifReportHasAuditData(report.id);

												return (
													<tr key={index}>
														<td className="date text-start d-none d-sm-table-cell">
															{report.dateCreated ? (
																<Moment format="MM/DD/YYYY">
																	{report.dateCreated}
																</Moment>
															) : (
																''
															)}
														</td>
														<td>
															{report.companyName}
															{report.googleBusinessUrl ? (
																<a
																	className="btn btn-link p-0"
																	href={report.googleBusinessUrl}
																	target="_blank"
																	title="View Google Business Profile"
																>
																	<i className="fa-solid fa-arrow-up-right-from-square ms-2" />
																</a>
															) : (
																<Fragment />
															)}
														</td>
														<td className="count d-none d-sm-table-cell">
															{report.keywordsCount}
														</td>
														<td className="report-status d-none d-sm-table-cell">
															{report.gridReportExists}
														</td>
														<td className="report-status d-none d-sm-table-cell">
															{auditReportExists ? 'Y' : 'N'}
														</td>
														<td className="report-status text-center d-none d-sm-table-cell">
															{report.reportStatus === 'Done' ? (
																<i className="fa-solid fa-check done" title="Done" />
															) : report.reportStatus === 'Error' ? (
																<i
																	className="fa-solid fa-triangle-exclamation error"
																	title="Error"
																/>
															) : (
																<Fragment />
															)}
														</td>
														<td className="task-action text-end">
															<Link
																to={`/reports/${report.id}`}
																className="btn btn-link py-0"
																title="View Report"
															>
																<i className="fa-solid fa-magnifying-glass-chart" />
															</Link>
															<button
																type="button"
																className="btn btn-link py-0 text-danger"
																title="Delete Report"
																onClick={(e) =>
																	handleDeleteReport(e, report.companyId, report.id)}
															>
																<i className="fa-solid fa-trash-can" />
															</button>
														</td>
													</tr>
												);
											})}
										</tbody>
									)}
								</Fragment>
							)}
							{!isLoading && (
								<TableFooter
									list={reportsPendingView}
									colspan={7}
									showRefreshButton={true}
									onListRefresh={() => getReportsList(true)}
								/>
							)}
						</table>
					</div>
				</div>
			</div>
		</Fragment>
	);
};

export default GridReportsList;
